import ComponentHelper from '../../../supers/ComponentHelper';
import RESTService from '../../../services/RESTService';
import Spinner from '../../../components/spinner/Spinner';
import React from 'react';

const connect = new RESTService();

class UserActivity extends ComponentHelper {
	constructor(props) {
		super(props);
		this.state = {
			fetchStatus: 'init',
			fetchError: null,
			activity: []
		};
	}

	componentDidMount() {
		this.setState({ fetchStatus: 'pending', fetchError: null });
		connect
			.getMyActivity()
			.then(activity => this.setState({ activity }))
			.catch(({ message }) => this.setState({ fetchStatus: 'failure', fetchError: message }));
	}

	render() {
		const { fetchStatus, fetchError, activity } = this.state;

		if (fetchStatus === 'pending') return <Spinner height="273px" text={`Loading user activity`} />;
		if (fetchStatus === 'failure') return <p className="error-msg">Error: {fetchError}</p>;

		return (
			<div className="user-activity animated fadeIn">
				<h2>Your activity</h2>
				{activity.length > 0 ? <ul>{activity.map((act, i) => <li key={i}>{act}</li>)}</ul> : <p>You have no activity yet.</p>}
			</div>
		);
	}
}

export default UserActivity;



// WEBPACK FOOTER //
// ./src/views/user-profile/user-activity/UserActivity.js